import { isProfessionalTileViewModel } from '@rocco/ui/tile-professional/view-models/professional';
import { isProjectTileViewModel } from '@rocco/ui/tile-project/view-models/project';
import { isProductTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import { isArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { TileActionInfo } from '../components/TileActionPanel';

/**
 * Item info for a tile's action surfaces — the mobile action-sheet header and
 * the save gate's brand pane — derived per view-model kind: professionals show
 * their logo in a circle, everything else its primary image in a square.
 */
export const buildTileActionInfo = (model: TileableModel): TileActionInfo => ({
    title: 'title' in model ? (model.title ?? '') : '',
    subtitle:
        isProductTileViewModel(model) ||
        isProjectTileViewModel(model) ||
        isArticleTileViewModel(model)
            ? (model.professional?.name ?? undefined)
            : undefined,
    image: isProfessionalTileViewModel(model)
        ? model.logo?.image?.src
        : isArticleTileViewModel(model)
          ? model.image?.src
          : isProductTileViewModel(model) || isProjectTileViewModel(model)
            ? model.images?.[0]?.src
            : undefined,
    imageShape: isProfessionalTileViewModel(model)
        ? ('circle' as const)
        : ('square' as const),
    imageBackground: isProfessionalTileViewModel(model)
        ? model.logo?.background
        : undefined,
});
